import { consultationQueries } from "lib/build/dashboards/ktx/queries";
import { Origin } from "lib/build/events";
import { resultMessages } from "lib/build/forms/ktx/transplantation-screening/consultations/transplantNephrology";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useLastEventByQuery } from "src/features/events";

export function useTransplantNephrology(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const event = useLastEventByQuery<{ result: string }>(
		consultationQueries.transplantNephrology
	);

	const formatMessageMap = useFormatMessageMap();
	return event === undefined
		? { value: "-" }
		: {
				value: formatMessageMap(resultMessages, event.value.result),
				timestamp: event.timestamp,
				origin: event.origin
			};
}
